import {ChannelStatus, GenderEnum} from '../../app/app.constants';

export enum InfluencerStatus {
  NEW = 0,
  ACTIVE = 1,
  INACTIVE = 2,
  DELETED = 3,
  PENDING_ACTIVE = 4
}

export class NewInfluencer {
  country: number;
  domain: string;
  email: string;
  gender: GenderEnum;
  activeChannels: number[] = [];
  languages: number[] = [];
  name: string;
  network: string;
  systemEmail: string;
  status: InfluencerStatus;
}

export class NewInfluencerChanel {
  influencerId: number;
  handle: string;
  platform_id: number;
  type: number;
  youtubeType: string;
  constructor(platformId: number, type?: number) {
    this.platform_id = platformId;
    this.type = type ? type : ChannelStatus.UNAUTHORIZE;
    // https://trello.com/c/yKLI6ZZA/1697-manually-adding-yt-channel-is-broken
    // Only allow to add Youtube Channel
    this.youtubeType = 'Channel';
  }
}



// WEBPACK FOOTER //
// ./src/models/influencer/new-influencer.ts